// Toggles visibility of comment thread on a form field response
const commentsToggle = $(".comments-toggle");

commentsToggle.on("click", function() {
  $(this)
    .parents(".form-value-group-item")
    .find(".comment-fields")
    .collapse("toggle");
});

// Sets hidden revocation flag field from a dropdown list item
const revocationFlagOptions = $("#revocation-flag-dropdown a");
revocationFlagOptions.on("click", function() {
  const revocationFlagField = $("#submission_revocation_flag");

  // Write selected value to hidden field
  const selectedFlag = this.dataset.revocationFlag;
  revocationFlagField.val(selectedFlag);

  // Toggle "Revoked" label on dropdown button
  const dropdownButton = revocationFlagField.siblings(".dropdown-toggle");
  const dropdownText = selectedFlag === "unset" ? "Flag" : "Revoked";
  dropdownButton.text(dropdownText);
});
